export const getJobGroups = state => state?.features?.jobGroups || {};
export const getError = state => getJobGroups(state)?.error;
export const getJobGroupsIds = state => getJobGroups(state)?.groupIds || [];
export const getIsLoading = state => getJobGroups(state)?.isLoading;
export const getPagination = state => getJobGroups(state)?.pagination;
export const getFilterOptions = state => getJobGroups(state)?.filterOptions;

export default {
  getError,
  getJobGroups,
  getJobGroupsIds,
  getIsLoading,
  getPagination,
  getFilterOptions,
};
